module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.crop),
      expression: "crop"
    }],
    staticClass: "upload-profile",
    attrs: {
      "id": "crop_wrap"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "upload_input",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.readImg
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "img",
      "src": _vm.imgsrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-profile-btn"
  }, [_c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    staticClass: "cancle",
    on: {
      "click": function($event) {
        _vm.cancle()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6d23c3ec"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpLoadProfile/index.vue
// module id = 182
// module chunks = 60